import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';
import { hash } from '@ember/helper';
import BvModalSection from 'volta/components/bv-modal/section';

import type { BvModalSectionSignature } from 'volta/components/bv-modal/section';
import type { ComponentLike } from '@glint/template';
import type { TOC } from '@ember/component/template-only';

export interface BvModalBodySignature {
  Args: {
    scrollable?: boolean;
    sectioned?: boolean;
    subdued?: boolean;
  };
  Blocks: {
    default: [props?: { Section: ComponentLike<BvModalSectionSignature> }];
  };
  Element: HTMLDivElement;
}

const BvModalBodyComponent: TOC<BvModalBodySignature> = <template>
  <div
    class={{classNames
      'bv-modal__body'
      (if @scrollable 'u-scrollable-y')
      (if @subdued 'u-bg-surface-overlay-subdued')
    }}
    ...attributes
  >
    {{#if (orElse @sectioned true)}}
      <BvModalSection>
        {{yield}}
      </BvModalSection>
    {{else}}
      {{yield (hash Section=(component BvModalSection))}}
    {{/if}}
  </div>
</template>;

export default BvModalBodyComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Body': typeof BvModalBodyComponent;
    'bv-modal/body': typeof BvModalBodyComponent;
  }
}
